import { render, staticRenderFns } from "./SeleccionarAsientosRegionAnexa.vue?vue&type=template&id=4661a918&scoped=true"
import script from "./SeleccionarAsientosRegionAnexa.vue?vue&type=script&lang=js"
export * from "./SeleccionarAsientosRegionAnexa.vue?vue&type=script&lang=js"
import style0 from "./SeleccionarAsientosRegionAnexa.vue?vue&type=style&index=0&id=4661a918&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4661a918",
  null
  
)

export default component.exports